export class PediatricPatientMeasurementHistoryModel {
    createdDate: Date;
    createdBy: number;
    measurements: string;
    createdByName: string;

    realData: any;
    monthAtMeasurement: number;
}

